export const VISIT_PIC_APP = 'visit_pic_app'
export const DELETE_PIC_SKU = 'delete_pic_sku'
export const MANAGE_PIC_DESIGN = 'manage_pic_design'
export const MANAGE_PIC_DESIGNER = 'manage_pic_designer'
export const MANAGE_PIC_PRODUCT = 'manage_pic_product'
export const manage_pic_attachment = 'manage_pic_attachment'
export const MANAGE_PIC_PACKAGE = 'manage_pic_package'
export const MANAGE_PIC_SKU_RULES = 'manage_pic_sku_rules'
export const VIEW_PIC_PERSONALIZE_DESIGN = 'view_pic_personalize_design'
export const MANAGE_PIC_PERSONALIZE_SERVICE = 'manage_pic_personalize_service'
export const WRITE_PIC_SALE_CHANNEL = 'write_pic_sale_channel'
export const WRITE_PIC_DATA_ISSUE = 'write_pic_data_issue'
